"use client";

import React from "react";
import { Scale, Shield, Lock, FileText, Users, Gavel } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const ethicsData = [{
  title: "Bağımsızlık",
  description: "Avukatlık mesleğinin temeli olan bağımsızlık ilkesi gereği, müvekkillerimizin haklarını savunurken hiçbir kurum, kişi veya güç odağının etkisi altında kalmadan, sadece hukukun ve vicdanın sesiyle hareket ederiz.",
  icon: Scale
}, {
  title: "Sır Saklama Yükümlülüğü",
  description: "Müvekkil-avukat ilişkisinin en kutsal unsuru olan gizlilik, büromuzun kırmızı çizgisidir. Edinilen her türlü bilgi ve belge, mesleki sır kapsamında özenle korunur ve üçüncü kişilerle asla paylaşılmaz.",
  icon: Lock
}, {
  title: "Sadakat ve Bağlılık",
  description: "Üstlendiğimiz her davada ve danışmanlık sürecinde, müvekkilimizin menfaatlerini hukuk çerçevesinde en üst düzeyde gözetir, şeffaf ve hesap verebilir bir temsil süreci yürütürüz.",
  icon: Shield
}, {
  title: "Reklam Yasağına Uyum",
  description: "Türkiye Barolar Birliği Reklam Yasağı Yönetmeliği'ne tam uyum sağlayarak, haksız rekabetten kaçınır; mesleğin itibarını zedeleyecek her türlü ticari görünüm ve davranıştan uzak dururuz.",
  icon: FileText
}, {
  title: "Dürüstlük ve Güven",
  description: "Hukuki süreçlerin her aşamasında müvekkillerimize karşı açık ve dürüst davranır, gerçekleşmesi mümkün olmayan vaatlerden kaçınarak, hukuki gerçeği tüm çıplaklığıyla ortaya koyarız.",
  icon: Users
}, {
  title: "Hukukun Üstünlüğü",
  description: "Tüm faaliyetlerimizde hukukun üstünlüğünü ve insan haklarını savunmayı bir görev bilir, adaletin tecellisi için mesleki bilgi ve birikimimizi etik kurallar çerçevesinde kullanırız.",
  icon: Gavel
}];
export default function ProfessionalEthics() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="mesleki-etik-ve-ilkeler" ref={ref} className={cn("dark bg-[#0a1118] bg-gradient-to-br from-[#0a1118] to-[#1a1c1e] text-foreground py-24 relative overflow-hidden transition-opacity duration-1000", isVisible ? "opacity-100" : "opacity-0")}>
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute left-0 top-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent opacity-20" />
        <div className="absolute left-0 bottom-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent opacity-20" />
        <div className="absolute left-1/2 top-0 w-px h-full bg-gradient-to-b from-transparent via-border to-transparent opacity-10 hidden md:block" />
      </div>

      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-20">
          <h2 className="text-3xl md:text-4xl font-serif font-medium tracking-tight mb-6 text-[#b8bfc6]">
            Mesleki Etik ve İlkelerimiz
          </h2>
          <Separator className="w-24 mx-auto mb-6 bg-[#c5a059]/40" />
          <p className="text-muted-foreground text-lg leading-relaxed font-sans font-light">
            Hukuk büromuz, avukatlık mesleğinin onuruna yakışır bir ciddiyetle,
            etik değerlerden ödün vermeden adalet hizmeti sunmayı taahhüt eder.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#c5a059]/10 border border-[#c5a059]/20">
          {ethicsData.map((item, i) => <div key={i} data-index={i} className="bg-background group relative">
              <Card className="h-full border-0 rounded-none shadow-none bg-transparent transition-colors duration-500 hover:bg-accent/5">
                <CardHeader className="pt-10 px-8 pb-4">
                  <div className="mb-6 inline-flex items-center justify-center w-12 h-12 rounded-full bg-[#c5a059]/10 text-[#c5a059] ring-1 ring-[#c5a059]/30 group-hover:bg-[#c5a059]/20 group-hover:scale-105 transition-all duration-500">
                    <item.icon className="w-5 h-5" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-xl font-serif font-medium tracking-wide text-[#b8bfc6] group-hover:text-[#c5a059] transition-colors duration-300">
                    {item.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="px-8 pb-10">
                  <p className="text-muted-foreground text-sm leading-7 font-sans font-light">
                    {item.description}
                  </p>
                </CardContent>
              </Card>
              
              {}
              <div className="absolute top-0 right-0 w-3 h-3 border-t border-r border-[#c5a059]/0 group-hover:border-[#c5a059]/30 transition-all duration-500" />
              <div className="absolute bottom-0 left-0 w-3 h-3 border-b border-l border-[#c5a059]/0 group-hover:border-[#c5a059]/30 transition-all duration-500" />
            </div>)}
        </div>
      </div>
    </section>;
}